<template>
  <a class="table-button-more" href="javascript:void(0)" v-on="$listeners">
    <icon class="table-button-more__icon" :type="`ios-arrow-${is_show ? 'up' : 'down'}`" />
    <span v-if="is_text" class="table-button-more__text">
      {{ $t(`shared.component.table.action.${is_show ? 'hide' : 'show'}`) }}
    </span>
  </a>
</template>

<script>
  export default {
    props: {
      is_show: {
        type: Boolean,
        default: false
      },
      is_text: {
        type: Boolean,
        default: true
      }
    }
  };
</script>

<style lang="scss" scoped>
  .table-button-more {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    text-decoration: none;

    &__icon {
      margin-right: 5px;
    }
  }
</style>
